<template>
  <div class="home-container">
    <!--头部-->
    <div class="home-header">
      <div v-show="!display.showSearch" class="header-title-box">
        <span class="title">万点上选首页</span>
        <van-icon name="search" @click="showSearch" class="search-icon" size="24"/>
      </div>
      <div v-show="display.showSearch" class="header-search-box">
        <searchHeader @goback="gobackToHome" from="home"></searchHeader>
      </div>
    </div>
    <!--轮播图-->
    <div class="banner-box">
      <van-swipe :autoplay="5000" indicator-color="#45C5DA">
        <van-swipe-item v-for="(item,index) in bannerList" :key="index" @click="gotoDetail(item)">
          <img v-bind:src="item.picUrl" v-lazy="item.picUrl" class="banner-img">
        </van-swipe-item>
      </van-swipe>
    </div>
    <!--推荐商铺-->
    <div class="shop-list-box">
      <div class="shop-item" v-for="(item,index) in shopList" :key="index" @click="gotoShop(item)">
        <div class="shop-item-img">
          <img v-bind:src="item.logo" v-lazy="item.logo" alt="">
        </div>
        <div class='shop-name overline'>{{item.name}}</div>
      </div>
    </div>
    <!--推荐商品-->
    <div class="goods-list-box">
      <div class="goods-header-title">精挑细选</div>
      <van-list
        v-model="display.loading"
        :finished="finished"
        finished-text="没有更多了"
        :immediate-check="false"
        @load="loadGoods"
      >
        <div></div>
        <div class="goods-item" v-for="(item, index) in goodsList" @click="gotoDetail2(item)">
          <div class="goods-image">
            <img v-bind:src="item.picUrl" alt="" v-lazy="item.picUrl">
          </div>
          <div class="goods-info">
            <span class="over2line goods-name" >{{item.name}}</span>
            <goodsPrice :price="item.price" :main-size="18"></goodsPrice>
          </div>
        </div>
      </van-list>
    </div>
  </div>
</template>

<script>
  import api from 'api/home';
  import goodsApi from 'api/goods-list';
  import userApi from 'api/user';
  import searchHeader from 'components/search-header';
  import {filterUrlPamram} from 'common/js/utils';
  import { getToken } from 'common/js/ovoSystem';
  import { mapState, mapActions } from 'vuex';
  import { getWxSign } from 'common/js/getSDKSign';
  import wx from 'weixin-js-sdk';
  import axios from 'axios';
  export default {
    components:{
      searchHeader,
    },
    data(){
      return {
        display:{
          showSearch: false,
          loading: false
        },
        page:{
          pageSize:5,
          pageNumber:1
        },
        bannerList:[],//轮播图列表
        shopList:[],//供应商列表
        goodsList:[],//商品列表
        finished: false,//推荐商品是否全部加载完成
      }
    },
    computed: {
      ...mapState(['userInfo'])
    },
    async created(){
      console.log(this.$route.query.code)
      // 如果没有token，则鉴权
      if (this.$route.query.code) {
        const code = this.$route.query.code;
        const data = await userApi.authentication(code);
        localStorage.setItem('ticket_wdsx', data.token);
        localStorage.setItem('userId_wdsx', data.userId);
        localStorage.setItem('ifExpired', '0');
        if (data.isBindPhone === 2) {
          this.$router.push({
            name: 'bindphone'
          })
        }
        if (!this.userInfo.id) {
          this.getuserInfo()
        }
      }else{

      }
      this.getBannerList();
      this.getShopList();
      this.getGoodsList();
    },
    mounted(){
    },
    methods:{
      //获取轮播图
      async getBannerList(){
        const data = await api.getBannerList();
        //排序
        this.bannerList = data.records.sort((a,b)=>a.sort - b.sort);
      },
      //获取推荐商铺
      async getShopList(){
        const data = await api.getShopList({
          pageSize:5,
          pageNumber: 1
        });
        //排序
        if (data.records.length > 0) {
          this.shopList = data.records.sort((a,b)=>a.sort - b.sort);
          this.shopList = this.shopList.slice(0, 5)
        }
      },
      //获取推荐商品
      async getGoodsList(){
        const data = await api.getGoodsList({
          pageSize: this.page.pageSize,
          pageNumber: this.page.pageNumber
        });
        this.display.loading = false;
        if (data.records.length < this.page.pageSize) {
          this.finished = true;
        }
        //排序
        this.goodsList = this.goodsList.concat(data.records);
        let that = this;
        //获取签名并初始化jssdk
        getWxSign(function () {
          const config = {
            title: '美方汲专业药妆商城', // 分享标题
            desc: '首页', // 分享描述
            link: window.location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
            imgUrl: that.goodsPicture, // 分享图标
            success: function () {
              console.log('分享成功');
            }
          }
          wx.onMenuShareAppMessage(config);
          wx.onMenuShareTimeline(config);
        })
      },
      //加载更多商品
      loadGoods(){
        this.page.pageNumber ++;
        this.getGoodsList();
      },
      //展示搜索框
      showSearch(){
        this.display.showSearch = true;
      },
      //隐藏搜索框
      gobackToHome(){
        this.display.showSearch = false;
      },
      //点击轮播图
      gotoDetail(item){
        //埋点
        goodsApi.setBannerClick(item.id)
        //获取跳转商品详情页的参数
        const params = item.jumpUrl.split('?')[1];
        if (params && params.indexOf('goodsId') > -1) {
          const goodsId = filterUrlPamram('goodsId',params);
          this.$router.push({
            path:'/goods-detail',
            query:{
              from:'home',
              goodsId:goodsId
            }
          })
        }
      },
      //点击推荐商品
      gotoDetail2(item){
        goodsApi.setGoodsClick(item.id)
        //跳转商品详情
        this.$router.push({
          path:'/goods-detail',
          query:{
            from:'home',
            goodsId: item.id
          }
        })
      },
      //点击商铺
      gotoShop(item){
        //埋点
        goodsApi.setSupplierClick(item.id)
        this.$router.push({
          path:'/goods-list',
          query:{
            supplierId: item.id,
            from: 'home'
          }
        })
      },
      ...mapActions(['getuserInfo'])
    }
  };
</script>

<style scoped lang="scss">
  @import 'common/sass/theme.scss';
  .home-container{
    .home-header{
      position: fixed;
      top: 0;
      width: 100%;
      z-index: 999;
      background: #fff;
      height: $header-search;
      .header-title-box{
        display: flex;
        position: relative;
        justify-content: center;
        align-items: center;
        width: 100%;
        height: 100%;
        border-bottom: 1px solid #ddd;
        .title{
        }
        .search-icon{
          position: absolute;
          right: 10px;
        }
      }
    }
    .banner-box{
      width: 100vw;
      height: 40vw;
      margin-top: 40px;
      overflow: hidden;
      .banner-img{
        display: inline-block;
        width: 100%;
        height: 100%;
      }
    }
    .shop-list-box{
      display: flex;
      justify-content: space-around;
      align-items: center;
      margin-top: 20px;
      font-size: 14px;
      color: $weight-word-color;
      .shop-item{
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        flex: 1;
        overflow: hidden;
        .shop-item-img{
          width: 40px;
          height: 40px;
          img{
            display: inline-block;
            width: 100%;
            height: 100%;
          }
        }
        .shop-name{
          width: 100%;
          text-align: center;
        }
      }
    }
    .goods-list-box{
      margin-top: 20px;
      padding-bottom: 50px;
      .goods-header-title{
        padding-left: 20px;
        font-weight: bold;
      }
      .goods-item{
        display: flex;
        padding: 10px;
        border-bottom: 1px solid $light-line-color;
        .goods-image{
          width: 75px;
          height: 75px;
          margin-right: 15px;
          img{
            display: inline-block;
            width: 100%;
            height: 100%;
          }
        }
        .goods-info{
          flex: 1;
          display: flex;
          flex-direction: column;
          justify-content: space-around;
          font-size: 14px;
          overflow: hidden;
          .goods-name{
            word-wrap:break-word
          }
        }
      }
    }
  }
</style>
